module.exports = __webpack_public_path__ + "static/media/MRI Illustration.5771732b.svg";